/**
 * Smooth open/close animation for `.accordion details` elements
 * (product Features/FAQs/Description, collapsible-content, custom FAQ).
 * Uses the Web Animations API to animate height instead of the abrupt
 * native details/summary toggle.
 */
(function () {
  var DURATION = 300;
  var EASING = 'ease-in-out';
  var STORAGE_PREFIX = 'accordion-open:';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var accordionState = new WeakMap();

  function restoreState(details) {
    if (!details.id) return;
    var saved = sessionStorage.getItem(STORAGE_PREFIX + details.id);
    if (saved !== null) {
      details.open = saved === '1';
    }
    details.addEventListener('toggle', function () {
      sessionStorage.setItem(STORAGE_PREFIX + details.id, details.open ? '1' : '0');
    });
  }

  document.querySelectorAll('.accordion details[id]').forEach(restoreState);

  function getState(details) {
    var current = accordionState.get(details);
    if (!current) {
      current = { animation: null, isClosing: false, isExpanding: false };
      accordionState.set(details, current);
    }
    return current;
  }

  function onAnimationFinish(details, open) {
    var state = getState(details);
    details.open = open;
    state.animation = null;
    state.isClosing = false;
    state.isExpanding = false;
    details.style.height = '';
    details.style.overflow = '';
  }

  function shrink(details) {
    var state = getState(details);
    var summary = details.querySelector('summary');
    state.isClosing = true;
    details.style.overflow = 'hidden';

    var startHeight = details.offsetHeight + 'px';
    var endHeight = summary.offsetHeight + 'px';

    if (state.animation) state.animation.cancel();

    state.animation = details.animate(
      { height: [startHeight, endHeight] },
      { duration: DURATION, easing: EASING }
    );
    state.animation.onfinish = function () {
      onAnimationFinish(details, false);
    };
    state.animation.oncancel = function () {
      state.isClosing = false;
    };
  }

  function expand(details) {
    var state = getState(details);
    var summary = details.querySelector('summary');
    var content = details.querySelector('.accordion__content');
    state.isExpanding = true;
    details.style.overflow = 'hidden';

    var startHeight = details.offsetHeight + 'px';
    var endHeight = summary.offsetHeight + content.offsetHeight + 'px';

    if (state.animation) state.animation.cancel();

    state.animation = details.animate(
      { height: [startHeight, endHeight] },
      { duration: DURATION, easing: EASING }
    );
    state.animation.onfinish = function () {
      onAnimationFinish(details, true);
    };
    state.animation.oncancel = function () {
      state.isExpanding = false;
    };
  }

  function open(details) {
    details.style.height = details.offsetHeight + 'px';
    details.open = true;
    window.requestAnimationFrame(function () {
      expand(details);
    });
  }

  function onSummaryClick(event) {
    var summary = event.target.closest('.accordion summary');
    if (!summary) return;

    var details = summary.closest('details');
    if (!details || !details.querySelector('.accordion__content')) return;
    if (typeof details.animate !== 'function' || reduceMotion) return;

    event.preventDefault();
    var state = getState(details);

    if (state.isClosing || !details.open) {
      open(details);
    } else if (state.isExpanding || details.open) {
      shrink(details);
    }
  }

  document.addEventListener('click', onSummaryClick);
})();
